module.exports = "<my-wagon-display my-wagon=\"$$wagon.data.myWagon\"\n  enable-buttons=\"true\"\n  enable-back=\"true\">\n</my-wagon-display>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/wagon/templates/details.html
// module id = 1535
// module chunks = 0